import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import PublicRoute from './components/PublicRoute';
import Spinner from './components/Spinner/intex';

const Login = lazy(() => import('./pages/Login'));
const LoginB = lazy(() => import('./pages/Login/indexB'));
const Home = lazy(() => import('./pages/Home'));
const Clothes = lazy(() => import('./pages/Clothes'));
const MyClothes = lazy(() => import('./pages/MyClothes'));
const Collection = lazy(() => import('./pages/Collection'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const NotFound = lazy(() => import('./pages/NotFound'));
const SizeGuide = lazy(() => import('./pages/SizeGuide'));

const App: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<Spinner />}>
        <Routes>

        {/* Publicas */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/loginBewell" element={<LoginB />} />
        </Route>
        {/* Publicas */}


        {/* Privadas */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/clothes" element={<Clothes />} />
            <Route path="/my-clothes" element={<MyClothes />} />
            {/* <Route path="/3d" element={<ThreeD />} /> */}
            <Route path="/size-guide" element={<SizeGuide />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        </Route>
        {/* Privadas */}

        <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
